export default __webpack_public_path__ + "static/DatBimIcon-4ada6b5eb310c61ae73fb14de054f1b5.png";